var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19C0 8.50659 8.50659 0 19 0C29.4934 0 38 8.50659 38 19C38 29.4934 29.4934 38 19 38C8.50659 38 0 29.4934 0 19Z",
    fill: "#DBE4FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2759_1090)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6907 12.3926C18.8893 12.3131 19.111 12.3131 19.3097 12.3926L27.643 15.7259C27.9594 15.8525 28.1668 16.1589 28.1668 16.4997V21.4997C28.1668 21.9599 27.7937 22.333 27.3335 22.333C26.8733 22.333 26.5002 21.9599 26.5002 21.4997V17.7305L24.8335 18.3972V22.333C24.8335 23.4715 23.9493 24.3257 22.9084 24.8461C21.8284 25.3861 20.4223 25.6663 19.0002 25.6663C17.5781 25.6663 16.1719 25.3861 15.092 24.8461C14.051 24.3257 13.1668 23.4715 13.1668 22.333V18.3972L10.3573 17.2734C10.041 17.1469 9.8335 16.8404 9.8335 16.4997C9.8335 16.1589 10.041 15.8525 10.3573 15.7259L18.6907 12.3926ZM14.3273 17.0663C14.3155 17.0613 14.3036 17.0565 14.2916 17.052L12.9106 16.4997L19.0002 14.0639L25.0897 16.4997L23.7087 17.052C23.6967 17.0565 23.6848 17.0613 23.6731 17.0663L19.0002 18.9355L14.3273 17.0663ZM14.8335 19.0639V22.333C14.8335 22.5206 15.0029 22.9382 15.8373 23.3554C16.6327 23.7531 17.7701 23.9997 19.0002 23.9997C20.2302 23.9997 21.3676 23.7531 22.163 23.3554C22.9974 22.9382 23.1668 22.5206 23.1668 22.333V19.0639L19.3097 20.6067C19.111 20.6862 18.8893 20.6862 18.6907 20.6067L14.8335 19.0639Z",
    fill: "#4C6EF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2759_1090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.16cae9ce6686d60f451800c168869f2e.svg";
export { ForwardRef as ReactComponent };